"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var alphabetizeItems = function alphabetizeItems(items) {
  return items.sort(function (a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
};

exports.default = alphabetizeItems;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/utils/alphabetizeItems.js
// module id = 684
// module chunks = 11